// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_LBR","cls2":"WorkCard-cls2_bm3 WorkCard-cls1_LBR"};